import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  glow?: boolean;
}

const Card: React.FC<CardProps> = ({ 
  children, 
  className = '', 
  hover = true,
  glow = false 
}) => {
  return (
    <div
      className={`
        card-game
        ${hover ? 'hover:scale-[1.02]' : ''}
        ${glow ? 'glow' : ''}
        ${className}
      `}
    >
      {children}
    </div>
  );
};

export default Card;

